<template>
  <!-- MASK API 메뉴얼 : https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#readme -->
  <masked-input

    type="text"
    v-bind="{ ...opt, ...$attrs,}"
    v-on="$listeners"

    class="imd-input-mask"
  >
  </masked-input>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      opt: {
        mask  : [/\d/, /\d/, /\d/,/\d/,'.', /\d/, /\d/,'.', /\d/, /\d/,],
        guide : true, // 가이드 보여준다.
        keepCharPositions : true, // 현재 입력된 글자 현재위치 유지
        placeholderChar : "_", // 입력칸 표시문자
        showMask: true, // 값이 비어있을때 마스크 미리 보여준다
      }
    }
  },
}
</script>

